export const BACKGROUND: string[] = ['#F8FAF4', '#FEF9F8', '#F9F5F9', '#F3F8FD', '#F1F4E6', '#FDF2F6', '#FEFBE6', '#EEF8FC', '#FEF8ED']
